import { Form } from '@bancobarigui/barihaus';

import { ProviderUserForm } from './ProviderUserForm';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';
import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { LoadingOverlay } from '@/components/LoadingOverlay';
import { ServiceCheck, FeatureAlert } from '@/shared/components';

import { useProviderUserRegister } from './useProviderUserRegister';

function ProviderUserRegisterContent() {
  const { onSubmit, isSubmitting } = useProviderUserRegister();

  return (
    <>
      <LoadingOverlay visible={isSubmitting} tip="Cadastrando usuário..." />

      <Form name="basic" onFinish={onSubmit} className="flex flex-col space-y-8">
        <ProviderUserForm />

        <RegisterFormButtons onClickCancel={() => {}} loading={isSubmitting} />
      </Form>
    </>
  );
}

export default function ProviderUserRegister() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Cadastrar novo usuário - Módulo Prestadora" />}
    >
      <FeatureAlert services={['user']} />
      <ServiceCheck services={['user']} featureName="Cadastro de Usuario Prestadora">
        <ProviderUserRegisterContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
